import { call, put, select, take, takeEvery, takeLatest } from "redux-saga/effects";
import { httpDelete, httpGet, httpPost, httpPut } from "../../services";
import { showLoadingAction } from "../actions/appStateActions";
import { AppBasicInfoSchema, initAppBasicInfoAction, initAppBasicInfoSuccessAction } from "../actions/authActions";
import {
  AppBasicSettingsAction,
  CaptchaSettingsSchema,
  DuoAuthenticationSchema,
  MFAAuthenticatorAppsAction,
  MFAAuthenticatorAppsSchema,
  MFAEmailOTPStatusSchema,
  MFASecurityQuestionsAction,
  MFASecurityQuestionsSchema,
  MFASettingsSchema,
  MFASmsOTPStatusSchema,
  PasswordCompliexitySchema,
  PasswordPolicyAction,
  PeriodicSchema,
  PinAuthAction,
  PinAuthSchema,
  PushNotificationSchema,
  RiskAuthSchema,
  RiskBasedAuthenticationAction,
  RiskFactor,
  SecurityQuestionAction,
  SecurityQuestionSchema,
  SecurityQuestionsAction,
  SecurityQuestionsSchema,
  UpdateMFAAuthenticatorAppsAction,
  UpdateMFASecurityQuestionsAction,
  UpdatePinAuthSchema,
  WebhookSecretsAction,
  WebhookSecretsSchema,
  addPushNotificationErrorAction,
  addPushNotificationLoadingAction,
  addPushNotificationSuccessAction,
  addpushNotificationAction,
  appBasicSettingsErrorAction,
  appBasicSettingsLoadingAction,
  appBasicSettingsSuccessAction,
  appInfoErrorAction,
  appInfoLoadingAction,
  appInfoSuccessAction,
  duoAuthenticationAction,
  fetchQuestionsRequest,
  getBreachedPasswordPolicyErrorAction,
  getBreachedPasswordPolicyLoadingAction,
  getBreachedPasswordPolicySuccessAction,
  getCaptchaSettingAction,
  getCaptchaSettingsErrorAction,
  getCaptchaSettingsLoadingAction,
  getCaptchaSettingsSuccessAction,
  getMfaAuthenticatorAppsErrorAction,
  getMfaAuthenticatorAppsLoadingAction,
  getMfaAuthenticatorAppsSuccessAction,
  getMfaEmailOtpStatusErrorAction,
  getMfaEmailOtpStatusLoadingAction,
  getMfaEmailOtpStatusSuccessAction,
  getMfaSecurityQuestionsErrorAction,
  getMfaSecurityQuestionsLoadingAction,
  getMfaSecurityQuestionsSuccessAction,
  getMfaSettingsErrorAction,
  getMfaSettingsLoadingAction,
  getMfaSettingsSuccessAction,
  getMfaSmsOtpStatusErrorAction,
  getMfaSmsOtpStatusLoadingAction,
  getMfaSmsOtpStatusSuccessAction,
  getPasswordComplexityErrorAction,
  getPasswordComplexityLoadingAction,
  getPasswordComplexitySuccessAction,
  getPeriodicPasswordErrorAction,
  getPeriodicPasswordLoadingAction,
  getPeriodicPasswordSuccessAction,
  getPinAuthErrorAction,
  getPinAuthLoadingAction,
  getPinAuthSuccessAction,
  getPushNotificationErrorAction,
  getPushNotificationLoadingAction,
  getPushNotificationSuccessAction,
  getRiskAuthSettingsErrorAction,
  getRiskAuthSettingsLoadingAction,
  getRiskAuthSettingsSuccessAction,
  getSecurityQuestionsErrorAction,
  getSecurityQuestionsLoadingAction,
  getSecurityQuestionsSuccessAction,
  getWebhookSecretsErrorAction,
  getWebhookSecretsLoadingAction,
  getWebhookSecretsSuccessAction,
  getduoAuthenticationErrorAction,
  getduoAuthenticationLoadingAction,
  getduoAuthenticationSuccessAction,
  mfaEmailOtpStatusAction,
  mfaSettingsAction,
  mfaSmsOtpStatusAction,
  postBreachedPasswordPolicyErrorAction,
  postBreachedPasswordPolicyLoadingAction,
  postBreachedPasswordPolicySuccessAction,
  pushNotificationAction,
  updateCaptchaSettingAction,
  updateCaptchaSettingsErrorAction,
  updateCaptchaSettingsLoadingAction,
  updateCaptchaSettingsSuccessAction,
  updateCountLimitFailure,
  updateCountLimitSuccess,
  updateDuoAuthenticationErrorAction,
  updateDuoAuthenticationLoadingAction,
  updateDuoAuthenticationSuccessAction,
  updateForceLogoutSettingConstAction,
  updateForceLogoutSettingErrorAction,
  updateForceLogoutSettingLoadingAction,
  updateForceLogoutSettingSuccessAction,
  updateMFAActions,
  updateMFAEmailOtpStatusAction,
  updateMFASettingsAction,
  updateMFASmsOtpStatusAction,
  updateMfaAuthenticatorAppsErrorAction,
  updateMfaAuthenticatorAppsLoadingAction,
  updateMfaAuthenticatorAppsSuccessAction,
  updateMfaEmailOtpStatusErrorAction,
  updateMfaEmailOtpStatusLoadingAction,
  updateMfaEmailOtpStatusSuccessAction,
  updateMfaSecurityQuestionsErrorAction,
  updateMfaSecurityQuestionsLoadingAction,
  updateMfaSecurityQuestionsSuccessAction,
  updateMfaSettingsErrorAction,
  updateMfaSettingsLoadingAction,
  updateMfaSettingsSuccessAction,
  updateMfaSmsOtpStatusErrorAction,
  updateMfaSmsOtpStatusLoadingAction,
  updateMfaSmsOtpStatusSuccessAction,
  updatePinAuthErrorAction,
  updatePinAuthLoadingAction,
  updatePinAuthSuccessAction,
  updatePushNotificationErrorAction,
  updatePushNotificationLoadingAction,
  updatePushNotificationSuccessAction,
  updateRemeberMeSettingConstAction,
  updateRemeberMeSettingErrorAction,
  updateRemeberMeSettingLoadingAction,
  updateRemeberMeSettingSuccessAction,
  updateRiskAuthSettingsErrorAction,
  updateRiskAuthSettingsLoadingAction,
  updateRiskAuthSettingsSuccessAction,
  updateSessionLimitErrorAction,
  updateSessionLimitLoadingAction,
  updateSessionLimitSettingAction,
  updateSessionLimitSuccessAction,
  updateEventBasedReAuthErrorAction,
  updateEventBasedReAuthLoadingAction,
  updateEventBasedReAuthSettingAction,
  updateEventBasedReAuthSuccessAction,
  updateSpamEmailDomainsErrorAction,
  updateSpamEmailDomainsLoadingAction,
  updateSpamEmailDomainsSettingAction,
  updateSpamEmailDomainsSuccessAction,
  updateduoAuthenticationAction,
  updatepushNotificationAction
} from "../actions/securityConfigurationActions";
import {
  getDomainAccessManagementError,
  getDomainAccessManagementRequest,
  getDomainAccessManagementSuccess,
  updateDomainAccessManagementError,
  updateDomainAccessManagementRequest,
  updateDomainAccessManagementSuccess
} from "../features/security/platformSecurity/domainAccessManagement";
import {
  getIpAccessManagementRequest,
  getIpAccessManagementSuccess,
  getIpAccessManagementError,
  updateIpAccessManagementRequest,
  updateIpAccessManagementSuccess,
  updateIpAccessManagementError
} from "../features/security/platformSecurity/ipAccessManagement";
import {
  getPasswordPolicy,
  getPasswordPolicySuccess,
  getPasswordPolicyError,
  updatePasswordPolicy,
  updatePasswordPolicySuccess,
  updatePasswordPolicyError
} from "../features/security/passwordPolicy/passwordPolicies";
import { UpdateUserProfileSchema } from "../actions/customerManagementActions";
import {
  getSecondFactorAuth,
  getSecondFactorAuthError,
  getSecondFactorAuthSuccess,
  updateSecondFactorAuth,
  updateSecondFactorAuthError,
  updateSecondFactorAuthSuccess
} from "../features/security/multiFactorAuthentication/secondFactorAuthentication";
import {
  getDuoSecondFactorAuth,
  getDuoSecondFactorAuthError,
  getDuoSecondFactorAuthSuccess,
  updateDuoSecondFactorAuth,
  updateDuoSecondFactorAuthError,
  updateDuoSecondFactorAuthSuccess
} from "../features/security/multiFactorAuthentication/duoSecondFactorAuthentication";
import {
  getGoogleAuthenticator,
  getGoogleAuthenticatorError,
  getGoogleAuthenticatorSuccess,
  updateGoogleAuthenticator,
  updateGoogleAuthenticatorError,
  updateGoogleAuthenticatorSuccess
} from "../features/security/multiFactorAuthentication/googleAuthenticator";
import {
  getPushNotification,
  getPushNotificationError,
  getPushNotificationSuccess,
  updatePushNotification,
  updatePushNotificationError,
  updatePushNotificationSuccess,
  addPushNotification,
  addPushNotificationError,
  addPushNotificationSuccess
} from "../features/security/multiFactorAuthentication/pushNotification";

import {
  getSecurityQuestionsAction,
  getSecurityQuestionsError,
  getSecurityQuestionsSuccess,
  updateSecurityQuestionsAction,
  updateSecurityQuestionsError,
  updateSecurityQuestionsSuccess,
  addSecurityQuestionsAction,
  addSecurityQuestionsError,
  addSecurityQuestionsSuccess,
  deleteSecurityQuestionsAction,
  deleteSecurityQuestionsError,
  deleteSecurityQuestionsSuccess,
  updateSecurityQuestionRenderCountSuccess,
  updateSecurityQuestionRenderCountError,
  updateSecurityQuestionRenderCountAction
} from "../features/security/multiFactorAuthentication/securityQuestions";
import {
  getDomainAccessRestrictionError,
  getDomainAccessRestrictionRequest,
  getDomainAccessRestrictionSuccess,
  updateDomainAccessRestrictionError,
  updateDomainAccessRestrictionRequest,
  updateDomainAccessRestrictionSuccess
} from "../features/security/platformSecurity/domainAccessRestriction";
import { RootSchema } from "../reducers";

/**
 * APP Info
 */
function* getAppInfoHandler() {
  try {
    yield put(appInfoLoadingAction());
    const data = yield httpGet("/platform-configuration/app-info");
    yield put(appInfoSuccessAction(data));
  } catch (e: any) {
    yield put(appInfoErrorAction(e.message));
  }
}
function* getPasswordComplexityHandler() {
  try {
    yield put(getPasswordComplexityLoadingAction());
    const data: PasswordCompliexitySchema = yield httpGet("/security-configuration/password-complexity");
    yield put(getPasswordComplexitySuccessAction(data));
  } catch (e: any) {
    yield put(getPasswordComplexityErrorAction(e.message));
  } finally {
    yield put(showLoadingAction(false));
  }
}
function* getPeriodicPasswordHandler() {
  try {
    yield put(getPeriodicPasswordLoadingAction());

    const data: PeriodicSchema = yield httpGet("/security-configuration/periodic-password");
    yield put(getPeriodicPasswordSuccessAction(data));
  } catch (e: any) {
    yield put(getPeriodicPasswordErrorAction(e.message));
  } finally {
    yield put(showLoadingAction(false));
  }
}
function* updateBasicSettings(data) {
  try {
    yield put(appBasicSettingsLoadingAction());
    const response: AppBasicInfoSchema = yield httpPost("/security-configuration/basic", {}, data);
    if (response.ErrorCode) {
      throw Error(response.Description || response.Message);
    }

    yield put(appBasicSettingsSuccessAction(response));
    if (!response.ErrorCode) {
      yield put(initAppBasicInfoSuccessAction(response));
    }
  } catch (e: any) {
    yield put(appBasicSettingsErrorAction(e.message));
  } finally {
    yield put(showLoadingAction(false));
  }
}
/**
 * Watchers
 */

export function* watchGetPasswordComplexityData() {
  while (true) {
    yield take(PasswordPolicyAction.GET_PASSWORD_COMPLEXITY);
    yield call(getPasswordComplexityHandler);
  }
}
export function* watchPriodicPasswordData() {
  while (true) {
    yield take(PasswordPolicyAction.GET_PERIODIC_PASSWORD);
    yield call(getPeriodicPasswordHandler);
  }
}

export function* watchGetAppInfo() {
  while (true) {
    yield take(PasswordPolicyAction.GET_APP_INFO);
    yield call(getAppInfoHandler);
  }
}
export function* watchGetAppBasicInfo() {
  while (true) {
    const { payload } = yield take(AppBasicSettingsAction.UPDATE_APP_BASIC_INFO);
    yield call(updateBasicSettings, payload.data);
  }
}
function* riskAuthSettingsAction() {
  try {
    let flag = false;
    yield put(getRiskAuthSettingsLoadingAction());
    const response: RiskAuthSchema = yield httpGet("/security-configuration/risk-based-auth");

    const defaultSettings: RiskFactor = {
      TimeRangeUnit: "Days",
      TimeRange: 1,
      IsEnabled: false,
      Actions: []
    };

    const defaultRiskFactors = {
      City: { ...defaultSettings },
      Country: { ...defaultSettings },
      Ip: { ...defaultSettings },
      Browser: { ...defaultSettings },
      Device: { ...defaultSettings }
    };

    if (response.ErrorCode) {
      if (response.ErrorCode === 8184) {
        yield put(getRiskAuthSettingsSuccessAction({ RiskFactors: defaultRiskFactors }));
      } else {
        throw Error(response.Description);
      }
    } else {
      // if RiskFactors is null, also use defaults
      const riskFactors = response.RiskFactors || defaultRiskFactors;

      for (const i in riskFactors) {
        if (riskFactors[i]?.IsEnabled && riskFactors[i].Actions?.includes("SecondFactorAuthentication")) {
          flag = true;
        }
      }

      yield put(getRiskAuthSettingsSuccessAction({ ...response, RiskFactors: riskFactors }));

      yield put(updateMFAActions({ isEnabled: flag }));
    }
  } catch (e: any) {
    yield put(getRiskAuthSettingsErrorAction(e.message));
  } finally {
    yield put(showLoadingAction(false));
  }
}
function* updateRiskAuthSettingsAction(data) {
  try {
    yield put(updateRiskAuthSettingsLoadingAction());
    const response: RiskAuthSchema = yield httpPut("/security-configuration/risk-based-auth", {}, data);
    if (response.ErrorCode) {
      throw Error(response.Description);
    }
    yield put(updateRiskAuthSettingsSuccessAction({ ...response, action: data.action }));
    yield put(getRiskAuthSettingsSuccessAction(response));
  } catch (e: any) {
    yield put(updateRiskAuthSettingsErrorAction(e.message));
  } finally {
    yield put(showLoadingAction(false));
  }
}

export function* watchGetRiskAuthSettings() {
  while (true) {
    yield take(RiskBasedAuthenticationAction.GET_RISK_AUTH_SETTINGS);
    yield call(riskAuthSettingsAction);
  }
}

export function* watchUpdateRiskAuthSettings() {
  while (true) {
    const { payload } = yield take(RiskBasedAuthenticationAction.UPDATE_RISK_AUTH_SETTINGS);
    yield call(updateRiskAuthSettingsAction, payload);
  }
}
function* getPinAuthSettings() {
  try {
    yield put(getPinAuthLoadingAction());

    const data: PinAuthSchema = yield httpGet("/security-configuration/pin-auth");
    if (data.ErrorCode) {
      throw Error(data.Description);
    }
    yield put(getPinAuthSuccessAction(data));
  } catch (e: any) {
    yield put(getPinAuthErrorAction(e.message));
  } finally {
    yield put(showLoadingAction(false));
  }
}
export function* watchGetPinAuth() {
  while (true) {
    yield take(PinAuthAction.PIN_AUTH);
    yield call(getPinAuthSettings);
  }
}

function* updatePinAuthSettingsAction(data) {
  try {
    yield put(updatePinAuthLoadingAction());
    const response: UpdatePinAuthSchema = yield httpPut("/security-configuration/pin-auth", {}, data);
    if (response.ErrorCode) {
      throw Error(response.Description);
    }
    yield put(updatePinAuthSuccessAction(response));
    yield put(getPinAuthSuccessAction(data));
  } catch (e: any) {
    yield put(updatePinAuthErrorAction(e.message));
  } finally {
    yield put(showLoadingAction(false));
  }
}

export function* watchUpdatePinAuthSettings() {
  while (true) {
    const { payload } = yield take(PinAuthAction.UPDATE_PIN_AUTH);
    yield call(updatePinAuthSettingsAction, payload);
  }
}

function* getSecurityQuestionsHandler() {
  try {
    yield put(getSecurityQuestionsLoadingAction());

    const data: SecurityQuestionsSchema = yield httpGet("/security-configuration/security-questions/render-count", {});

    yield put(getSecurityQuestionsSuccessAction({ ...data }));
  } catch (e) {
    yield put(getSecurityQuestionsErrorAction(e.message));
  }
}

function* getMFASecurityQuestionsHandler() {
  try {
    yield put(getMfaSecurityQuestionsLoadingAction());

    const data: MFASecurityQuestionsSchema = yield httpGet("/security-configuration/mfa/securityquestions", {});
    if (data.ErrorCode) {
      throw Error(data.Description);
    }
    yield put(getMfaSecurityQuestionsSuccessAction({ ...data }));
  } catch (e) {
    yield put(getMfaSecurityQuestionsErrorAction(e.message));
  }
}

function* updateMFASecurityQuestionsHandler(data) {
  try {
    yield put(updateMfaSecurityQuestionsLoadingAction());
    const response: MFASecurityQuestionsSchema = yield httpPut(
      "/security-configuration/mfa/securityquestions",
      {},
      {
        IsEnabled: data.IsEnabled,
        MinimumQuestionsToAsk: data.MinimumQuestionsToAsk
      }
    );
    if (response.ErrorCode) {
      throw Error(response.Message);
    }
    yield put(updateMfaSecurityQuestionsSuccessAction(response));
    yield put(getMfaSecurityQuestionsSuccessAction(data));
  } catch (e: any) {
    yield put(updateMfaSecurityQuestionsErrorAction(e.message));
  }
}

function* getMFAAuthenticatorAppsHandler() {
  try {
    yield put(getMfaAuthenticatorAppsLoadingAction());

    const data: MFAAuthenticatorAppsSchema = yield httpGet("/security-configuration/two-factor-auth/google-authenticator-settings", {});
    if (data.ErrorCode) {
      throw Error(data.Description);
    }
    yield put(getMfaAuthenticatorAppsSuccessAction({ ...data }));
  } catch (e) {
    yield put(getMfaAuthenticatorAppsErrorAction(e.message));
  }
}

function* updateMFAAuthenticatorAppsHandler(data) {
  try {
    yield put(updateMfaAuthenticatorAppsLoadingAction());
    const response: MFAAuthenticatorAppsSchema = yield httpPost("/security-configuration/two-factor-auth/google-authenticator-settings", {}, data);
    if (response.ErrorCode) {
      throw Error(response.Description);
    }
    yield put(updateMfaAuthenticatorAppsSuccessAction(response));
    yield put(getMfaAuthenticatorAppsSuccessAction(data));
  } catch (e: any) {
    yield put(updateMfaAuthenticatorAppsErrorAction(e.message));
  }
}

function* getMFASettingsHandler() {
  try {
    yield put(getMfaSettingsLoadingAction());

    const data: MFASettingsSchema = yield httpGet("/security-configuration/two-factor-auth/second-factor/status", {});
    if (data.ErrorCode) {
      throw Error(data.Description);
    }
    yield put(getMfaSettingsSuccessAction({ ...data }));
  } catch (e) {
    yield put(getMfaSettingsErrorAction(e.message));
  }
}

function* updateMFASettingsHandler(data) {
  try {
    yield put(updateMfaSettingsLoadingAction());
    const response: MFASettingsSchema = yield httpPost("/security-configuration/two-factor-auth/second-factor/status", {}, data);
    if (response.ErrorCode) {
      throw Error(response.Description);
    }
    yield put(updateMfaSettingsSuccessAction(response));
    yield put(getMfaSettingsSuccessAction(data));
  } catch (e: any) {
    yield put(updateMfaSettingsErrorAction(e.message));
  }
}

function* getMFAEmailStatusHandler() {
  try {
    yield put(getMfaEmailOtpStatusLoadingAction());

    const data: MFAEmailOTPStatusSchema = yield httpGet("/security-configuration/mfaemailotpstatus", {});
    if (data.ErrorCode) {
      throw Error(data.Description);
    }
    yield put(getMfaEmailOtpStatusSuccessAction({ ...data }));
  } catch (e) {
    yield put(getMfaEmailOtpStatusErrorAction(e.message));
  }
}

function* updateMFAEmailStatusHandler(data) {
  try {
    yield put(updateMfaEmailOtpStatusLoadingAction());
    const response: MFAEmailOTPStatusSchema = yield httpPut("/security-configuration/mfaemailotpstatus", {}, data);
    if (response.ErrorCode) {
      throw Error(response.Description);
    }
    yield put(updateMfaEmailOtpStatusSuccessAction(response));
    yield put(getMfaEmailOtpStatusSuccessAction(data));
  } catch (e: any) {
    yield put(updateMfaEmailOtpStatusErrorAction(e.message));
  }
}

function* getMFASmsStatusHandler() {
  try {
    yield put(getMfaSmsOtpStatusLoadingAction());

    const data: MFASmsOTPStatusSchema = yield httpGet("/security-configuration/two-factor-auth/second-factor/otp/status", {});
    if (data.ErrorCode) {
      throw Error(data.Description);
    }
    yield put(getMfaSmsOtpStatusSuccessAction({ ...data }));
  } catch (e) {
    yield put(getMfaSmsOtpStatusErrorAction(e.message));
  }
}

function* updateMFASmsStatusHandler(data) {
  try {
    yield put(updateMfaSmsOtpStatusLoadingAction());
    const response: MFASmsOTPStatusSchema = yield httpPost("/security-configuration/two-factor-auth/second-factor/otp/status", {}, data);
    if (response.ErrorCode) {
      throw Error(response.Description);
    }
    yield put(updateMfaSmsOtpStatusSuccessAction(response));
    yield put(getMfaSmsOtpStatusSuccessAction(data));
  } catch (e: any) {
    yield put(updateMfaSmsOtpStatusErrorAction(e.message));
  }
}

function* getPushNotificationHandler() {
  try {
    yield put(getPushNotificationLoadingAction());

    const data: PushNotificationSchema = yield httpGet("/security-configuration/two-factor-auth/push-notification-settings", {});
    if (data.ErrorCode) {
      throw Error(data.Description);
    }
    yield put(getPushNotificationSuccessAction({ ...data }));
  } catch (e) {
    yield put(getPushNotificationErrorAction(e.message));
  }
}

function* addPushNotificationHandler(data) {
  try {
    yield put(addPushNotificationLoadingAction());
    const response: PushNotificationSchema = yield httpPost("/security-configuration/two-factor-auth/push-notification-settings", {}, data);
    if (response.ErrorCode) {
      throw Error(response.Description);
    }
    yield put(addPushNotificationSuccessAction(response));
    yield put(getPushNotificationSuccessAction(response));
  } catch (e: any) {
    yield put(addPushNotificationErrorAction(e.message));
  }
}

function* updatePushNotificationHandler(data) {
  try {
    yield put(updatePushNotificationLoadingAction());
    const response: PushNotificationSchema = yield httpPut("/security-configuration/two-factor-auth/push-notification-settings", {}, data);
    if (response.ErrorCode) {
      throw Error(response.Description);
    }
    yield put(updatePushNotificationSuccessAction(response));
    yield put(getPushNotificationSuccessAction(response));
  } catch (e: any) {
    yield put(updatePushNotificationErrorAction(e.message));
  }
}

function* getDuoAuthenticationHandler() {
  try {
    yield put(getduoAuthenticationLoadingAction());

    const data: DuoAuthenticationSchema = yield httpGet("/security-configuration/two-factor-auth/duo-settings", {});
    if (data.ErrorCode) {
      throw Error(data.Description);
    }
    yield put(getduoAuthenticationSuccessAction({ ...data }));
  } catch (e) {
    yield put(getduoAuthenticationErrorAction(e.message));
  }
}

function* updateduoAuthenticationHandler(data) {
  try {
    yield put(updateDuoAuthenticationLoadingAction());
    const response: DuoAuthenticationSchema = yield httpPut("/security-configuration/two-factor-auth/duo-settings", {}, data);
    if (response.ErrorCode) {
      throw Error(response.Description);
    }
    yield put(updateDuoAuthenticationSuccessAction(response));
    yield put(getduoAuthenticationSuccessAction(response));
  } catch (e: any) {
    yield put(updateDuoAuthenticationErrorAction(e.message));
  }
}

function* getBreachedPasswordPolicyHandler() {
  try {
    yield put(getBreachedPasswordPolicyLoadingAction());
    const data: any = yield httpGet("/security-configuration/passwordpolicy/breachedpassword");
    yield put(getBreachedPasswordPolicySuccessAction(data));
  } catch (e) {
    yield put(getBreachedPasswordPolicyErrorAction(e.message));
  } finally {
    yield put(showLoadingAction(false));
  }
}

function* getDomainAccessManagementHandler() {
  try {
    const data: any = yield httpGet("/security-configuration/restriction/config");
    if (data.ErrorCode === 927 || data.ListType === "none") {
      yield put(getDomainAccessManagementSuccess({ IsEnabled: false }));
    } else yield put(getDomainAccessManagementSuccess({ IsEnabled: true, data: data }));
  } catch (e) {
    yield put(getDomainAccessManagementError(e.message));
  } finally {
    yield put(showLoadingAction(false));
  }
}

function* updateDomainAccessManagementHandler(action) {
  try {
    const data: any = yield httpPost("/security-configuration/restriction/config", {}, action.payload);
    if (data.ErrorCode) {
      throw Error(data.Description);
    } else {
      yield put(updateDomainAccessManagementSuccess({ data: data }));
    }
  } catch (e) {
    yield put(updateDomainAccessManagementError(e.message));
  } finally {
    yield put(showLoadingAction(false));
  }
}

function* getIpAccessManagementHandler() {
  try {
    const data: any = yield httpGet("/security-configuration/ip-config");
    if (data?.ErrorCode) {
      throw Error(data.Description);
    }
    yield put(getIpAccessManagementSuccess(data || {}));
  } catch (e) {
    yield put(getIpAccessManagementError(e.Description || e.Message || e.message || "Unable to load IP access configuration. Please try again."));
  } finally {
    yield put(showLoadingAction(false));
  }
}

// The six config fields the API echoes back. Used to tell a full config response
// apart from a bare mutation ack, so the refetch below only runs when it must.
const IP_CONFIG_FIELDS = ["IsEnabled", "AllowedIPs", "DeniedIPs", "IsAuthEnabled", "AuthAllowedIPs", "AuthDeniedIPs"];
// `every`, not `some`: the point is to tell a FULL config apart from a bare ack, and a response
// echoing only the fields just sent would pass a `some` test while carrying nothing about the other
// scope. Falling short here costs one extra GET below, which is always safe.
const isIpConfigResponse = (data: any) => Boolean(data) && IP_CONFIG_FIELDS.every((field) => field in data);

function* updateIpAccessManagementHandler(action) {
  const { scope, requestId, config, successMessage } = action.payload;
  try {
    const data: any = yield httpPut("/security-configuration/ip-config", {}, config);
    if (data?.ErrorCode) {
      // Description names the offending entries and lists (e.g. 8018 overlap); keep it verbatim.
      throw Error(data.Description || data.Message);
    }
    // A PUT returns the full resolved config, so it is used as-is. Older builds answered
    // with a bare ack (`{ Edited: true }`) — fall back to a read so the store still holds
    // canonical server state rather than the partial body we just sent.
    let persisted = data;
    if (!isIpConfigResponse(data)) {
      try {
        const fresh: any = yield httpGet("/security-configuration/ip-config");
        persisted = fresh?.ErrorCode ? { ...config } : fresh || {};
      } catch {
        // The write succeeded; only the read-back failed. Report what we know was persisted
        // rather than surfacing a false failure — the next GET reconciles the rest.
        persisted = { ...config };
      }
    }
    yield put(updateIpAccessManagementSuccess({ requestId, scope, data: persisted, successMessage }));
  } catch (e) {
    yield put(updateIpAccessManagementError({ requestId, scope, error: e.Description || e.Message || e.message || "Unable to update IP access configuration. Please try again." }));
  } finally {
    yield put(showLoadingAction(false));
  }
}

function* getDomainAccessRestrictionHandler() {
  try {
    const data: any = yield httpGet("/security-configuration/restriction/type");
    if (data.ErrorCode) {
      throw Error(data.Description);
    } else yield put(getDomainAccessRestrictionSuccess(data));
  } catch (e) {
    yield put(getDomainAccessRestrictionError(e.message));
  } finally {
    yield put(showLoadingAction(false));
  }
}

function* updateDomainAccessRestrictionHandler(action) {
  try {
    const data: any = yield httpPut("/security-configuration/restriction/type", {}, action.payload);
    if (data.ErrorCode) {
      throw Error(data.Description);
    } else {
      yield put(updateDomainAccessRestrictionSuccess(data));
    }
  } catch (e) {
    yield put(updateDomainAccessRestrictionError(e.message));
  } finally {
    yield put(showLoadingAction(false));
  }
}

export function* watchGetDomainAccessManagement() {
  yield takeLatest(getDomainAccessManagementRequest.type, getDomainAccessManagementHandler);
  yield takeLatest(updateDomainAccessManagementRequest.type, updateDomainAccessManagementHandler);
}

export function* watchDomainAccessRestriction() {
  yield takeLatest(getDomainAccessRestrictionRequest.type, getDomainAccessRestrictionHandler);
  yield takeLatest(updateDomainAccessRestrictionRequest.type, updateDomainAccessRestrictionHandler);
}

export function* watchIpAccessManagement() {
  yield takeLatest(getIpAccessManagementRequest.type, getIpAccessManagementHandler);
  // takeEvery, not takeLatest: the manage and auth sections write disjoint scopes, so two
  // in-flight saves cannot clobber each other — and cancelling one would leave its section
  // spinning forever (it settles on its own scope's result).
  yield takeEvery(updateIpAccessManagementRequest.type, updateIpAccessManagementHandler);
}

export function* watchGetBreachedPasswordPolicy() {
  while (true) {
    yield take(PasswordPolicyAction.GET_BREACHED_PASSWORD_POLICY);
    yield call(getBreachedPasswordPolicyHandler);
  }
}

function* postBreachedPasswordPolicyHandler(data) {
  try {
    yield put(postBreachedPasswordPolicyLoadingAction());
    const response: any = yield httpPut("/security-configuration/passwordpolicy/breachedpassword", {}, data);
    yield put(postBreachedPasswordPolicySuccessAction(response));
  } catch (e) {
    yield put(postBreachedPasswordPolicyErrorAction(e.message));
  } finally {
    yield put(showLoadingAction(false));
  }
}
export function* watchPostBreachedPasswordPolicy() {
  while (true) {
    const { payload } = yield take(PasswordPolicyAction.POST_BREACHED_PASSWORD_POLICY);
    yield call(postBreachedPasswordPolicyHandler, payload);
  }
}

function* updateForceLogoutSettingHandler(data) {
  try {
    yield put(updateForceLogoutSettingLoadingAction());
    const response: any = yield httpPost("/security-configuration/submit-advanced-get-advanced", {}, data);
    if (response.ErrorCode) {
      throw Error(response.Description);
    }
    yield put(updateForceLogoutSettingSuccessAction(response));
  } catch (e: any) {
    yield put(updateForceLogoutSettingErrorAction(e.message));
  }
}

export function* watchUpdateForceLogoutSetting() {
  while (true) {
    const { payload } = yield take(updateForceLogoutSettingConstAction.UPDATE_FORCE_LOGOUT);
    yield call(updateForceLogoutSettingHandler, payload);
  }
}

function* updateRemeberMeSettingHandler(data) {
  try {
    yield put(updateRemeberMeSettingLoadingAction());
    const response: any = yield httpPost("/security-configuration/submit-basic-get-basic", {}, data);
    if (response.ResponseSubmit.ErrorCode || response.Response.ErrorCode) {
      throw Error(response.ResponseSubmit.Description || response.Response.Description);
    }
    yield put(updateRemeberMeSettingSuccessAction(response));
  } catch (e: any) {
    yield put(updateRemeberMeSettingErrorAction(e.message));
  }
}

export function* watchUpdateRemeberMeSetting() {
  while (true) {
    const { payload } = yield take(updateRemeberMeSettingConstAction.UPDATE_REMEBER_ME);
    yield call(updateRemeberMeSettingHandler, payload);
  }
}

function* updateSessionLimitSettingHandler(data) {
  try {
    yield put(updateSessionLimitLoadingAction());
    const limitResponse: any = yield httpPost("/security-configuration/submit-basic-get-basic", {}, { LoginSharingConfig: { IsEnabled: data.Enabled, SessionsLimit: data.SessionsLimit } });
    if (limitResponse.ErrorCode) {
      throw Error(limitResponse.Description);
    }

    const loginSharingConfig = limitResponse.Response?.LoginSharingConfig || {};

    yield put(
      updateSessionLimitSuccessAction({
        Enabled: loginSharingConfig.IsEnabled ?? false,
        SessionsLimit: loginSharingConfig.SessionsLimit ?? limitResponse.Response?.SessionsLimit ?? 0
      })
    );
  } catch (e: any) {
    yield put(updateSessionLimitErrorAction(e.message));
  }
}

export function* watchUpdateSessionLimitSetting() {
  while (true) {
    const { payload } = yield take(updateSessionLimitSettingAction.UPDATE_SESSION_LIMIT);
    yield call(updateSessionLimitSettingHandler, payload);
  }
}

function* updateEventBasedReAuthHandler(data) {
  try {
    yield put(updateEventBasedReAuthLoadingAction());
    const response: any = yield httpPost("/security-configuration/submit-basic-get-basic", {}, { EventBasedReAuthentication: { IsEnabled: data.IsEnabled } });
    if (response.ErrorCode) {
      throw Error(response.Description);
    }

    const cfg = response.Response?.EventBasedReAuthentication || {};
    yield put(updateEventBasedReAuthSuccessAction({ IsEnabled: cfg.IsEnabled ?? false }));
  } catch (e: any) {
    yield put(updateEventBasedReAuthErrorAction(e.message));
  }
}

export function* watchUpdateEventBasedReAuth() {
  while (true) {
    const { payload } = yield take(updateEventBasedReAuthSettingAction.UPDATE_EVENT_BASED_REAUTH);
    yield call(updateEventBasedReAuthHandler, payload);
  }
}

function* updateSpamEmailDomainsHandler(data) {
  try {
    yield put(updateSpamEmailDomainsLoadingAction());
    const response: any = yield httpPost("/security-configuration/submit-basic-get-basic", {}, { SpamEmailDomainsConfig: { IsEnabled: data.IsEnabled } });
    if (response.ErrorCode) {
      throw Error(response.Description);
    }

    const cfg = response.Response?.SpamEmailDomainsConfig || {};
    yield put(updateSpamEmailDomainsSuccessAction({ IsEnabled: cfg.IsEnabled ?? false }));
    // Keep the cached app basic settings in sync so other screens read the new value
    // without an extra round-trip (the endpoint echoes back the full basic settings).
    if (response.Response) {
      yield put(initAppBasicInfoSuccessAction(response.Response));
    }
  } catch (e: any) {
    yield put(updateSpamEmailDomainsErrorAction(e.message));
  }
}

export function* watchUpdateSpamEmailDomains() {
  while (true) {
    const { payload } = yield take(updateSpamEmailDomainsSettingAction.UPDATE_SPAM_EMAIL_DOMAINS);
    yield call(updateSpamEmailDomainsHandler, payload);
  }
}

function* getCaptchaSettingsHandler() {
  try {
    yield put(getCaptchaSettingsLoadingAction());

    const data: CaptchaSettingsSchema = yield httpGet("/security-configuration/captcha", {});
    if (data.ErrorCode) {
      throw Error(data.Description);
    }
    yield put(getCaptchaSettingsSuccessAction({ ...data }));
  } catch (e) {
    yield put(getCaptchaSettingsErrorAction(e.message));
  }
}

function* updateCaptchaSettingsHandler(data) {
  try {
    yield put(updateCaptchaSettingsLoadingAction());
    const response: CaptchaSettingsSchema = yield httpPut("/security-configuration/captcha", {}, data);
    if (response.ErrorCode) {
      throw Error(response.Message || response.Description);
    }
    yield put(updateCaptchaSettingsSuccessAction(response));
    yield put(getCaptchaSettingsSuccessAction(response));
    // yield put(getduoAuthenticationSuccessAction(response));
  } catch (e: any) {
    yield put(updateCaptchaSettingsErrorAction(e.message));
  }
}

export function* watchGetSecurityQuestions() {
  while (true) {
    yield take(SecurityQuestionsAction.GET_SECURITY_QUESTIONS);
    yield call(getSecurityQuestionsHandler);
  }
}

export function* watchMfaGetSecurityQuestions() {
  while (true) {
    yield take(MFASecurityQuestionsAction.GET_MFA_SECURITY_QUESTIONS);
    yield call(getMFASecurityQuestionsHandler);
  }
}

export function* watchUpdateMfaGetSecurityQuestions() {
  while (true) {
    const { payload } = yield take(UpdateMFASecurityQuestionsAction.UPDATE_MFA_SECURITY_QUESTIONS);
    yield call(updateMFASecurityQuestionsHandler, payload);
  }
}

export function* watchMfaGetAuthenticatorApps() {
  while (true) {
    yield take(MFAAuthenticatorAppsAction.GET_MFA_AUTHENTICATOR_APPS);
    yield call(getMFAAuthenticatorAppsHandler);
  }
}

export function* watchUpdateMfaAuthenticatorApps() {
  while (true) {
    const { payload } = yield take(UpdateMFAAuthenticatorAppsAction.UPDATE_MFA_AUTHENTICATOR_APPS);
    yield call(updateMFAAuthenticatorAppsHandler, payload);
  }
}

export function* watchMfaGetSettings() {
  while (true) {
    yield take(mfaSettingsAction.GET_MFA_SETTINGS);
    yield call(getMFASettingsHandler);
  }
}

export function* watchUpdateMfaSettings() {
  while (true) {
    const { payload } = yield take(updateMFASettingsAction.UPDATE_MFA_SETTINGS);
    yield call(updateMFASettingsHandler, payload);
  }
}

export function* watchMfaGetEmailStatus() {
  while (true) {
    yield take(mfaEmailOtpStatusAction.GET_MFA_EMAIL_STATUS);
    yield call(getMFAEmailStatusHandler);
  }
}

export function* watchUpdateMfaEmailStatus() {
  while (true) {
    const { payload } = yield take(updateMFAEmailOtpStatusAction.UPDATE_MFA_EMAIL_STATUS);
    yield call(updateMFAEmailStatusHandler, payload);
  }
}
export function* watchMfaGetSmsStatus() {
  while (true) {
    yield take(mfaSmsOtpStatusAction.GET_MFA_SMS_STATUS);
    yield call(getMFASmsStatusHandler);
  }
}

export function* watchUpdateMfaSmsStatus() {
  while (true) {
    const { payload } = yield take(updateMFASmsOtpStatusAction.UPDATE_MFA_SMS_STATUS);
    yield call(updateMFASmsStatusHandler, payload);
  }
}
export function* watchPushNotification() {
  while (true) {
    yield take(pushNotificationAction.GET_PUSH_NOTIFICATION);
    yield call(getPushNotificationHandler);
  }
}

export function* watchAddPushNotification() {
  while (true) {
    const { payload } = yield take(addpushNotificationAction.ADD_PUSH_NOTIFICATION);
    yield call(addPushNotificationHandler, payload);
  }
}

export function* watchUpdatePushNotification() {
  while (true) {
    const { payload } = yield take(updatepushNotificationAction.UPDATE_PUSH_NOTIFICATION);
    yield call(updatePushNotificationHandler, payload);
  }
}

export function* watchDuoAuthentication() {
  while (true) {
    yield take(duoAuthenticationAction.GET_DUO_AUTHENTICATION);
    yield call(getDuoAuthenticationHandler);
  }
}
export function* watchUpdateDuoAuthentication() {
  while (true) {
    const { payload } = yield take(updateduoAuthenticationAction.UPDATE_DUO_AUTHENTICATION);
    yield call(updateduoAuthenticationHandler, payload);
  }
}
function* getWebhookSecretsHandler() {
  try {
    yield put(getWebhookSecretsLoadingAction());

    const data: WebhookSecretsSchema = yield httpGet("/security-configuration/api-credentials/secondary-secret", {
      fields: "Data(Description,Roles)"
    });

    yield put(getWebhookSecretsSuccessAction({ ...data }));
  } catch (e) {
    yield put(getWebhookSecretsErrorAction(e.message));
  }
}

export function* watchGetWebhookSecrets() {
  while (true) {
    yield take(WebhookSecretsAction.GET_WEBHOOK_SECRETS_OPTIONS);
    yield call(getWebhookSecretsHandler);
  }
}

export function* watchCaptchaSettings() {
  while (true) {
    yield take(getCaptchaSettingAction.GET_CAPTCHA_SETTING);
    yield call(getCaptchaSettingsHandler);
  }
}
export function* watchUpdateCaptchaSettings() {
  while (true) {
    const { payload } = yield take(updateCaptchaSettingAction.UPDATE_CAPTCHA_SETTING);
    yield call(updateCaptchaSettingsHandler, payload);
  }
}

function* getPasswordPolicyHandler() {
  try {
    const data = yield httpGet(`/security-configuration/password-policy`);
    if (data.ErrorCode) {
      throw new Error(data.Message);
    }
    yield put(getPasswordPolicySuccess(data));
  } catch (e) {
    yield put(getPasswordPolicyError(e.message));
  }
}

function* updatePasswordPolicyHandler(payload: any) {
  try {
    const data: UpdateUserProfileSchema = yield httpPut("/security-configuration/password-policy", {}, payload.payload);
    if (data.ErrorCode) {
      throw new Error(data.Message);
    }
    yield put(updatePasswordPolicySuccess(data));
  } catch (e) {
    yield put(updatePasswordPolicyError(e.message));
  }
}

export function* watchPasswordPolicy() {
  yield takeLatest(getPasswordPolicy.type, getPasswordPolicyHandler);
  yield takeLatest(updatePasswordPolicy.type, updatePasswordPolicyHandler);
}

function* getSecondFactorAuthHandler() {
  try {
    const data = yield httpGet(`/security-configuration/two-factor-auth/second-factor/status`);
    if (data.ErrorCode) {
      throw new Error(data.Message);
    }
    yield put(getSecondFactorAuthSuccess(data));
  } catch (e) {
    yield put(getSecondFactorAuthError(e.message));
  }
}

function* updateSecondFactorAuthHandler(payload: any) {
  try {
    const data = yield httpPost("/security-configuration/two-factor-auth/second-factor/status", {}, payload.payload);
    if (data.ErrorCode) {
      throw new Error(data.Message);
    }
    yield put(updateSecondFactorAuthSuccess(data));
  } catch (e) {
    yield put(updateSecondFactorAuthError(e.message));
  }
}

export function* watchSecondFactorAuth() {
  yield takeLatest(getSecondFactorAuth.type, getSecondFactorAuthHandler);
  yield takeLatest(updateSecondFactorAuth.type, updateSecondFactorAuthHandler);
}

function* getSecurityquestionsHandler() {
  try {
    const data = yield httpGet(`/security-configuration/security-questions/render-count`);
    if (data.ErrorCode) {
      throw new Error(data.Message);
    }
    yield put(getSecurityQuestionsSuccess(data));
  } catch (e) {
    yield put(getSecurityQuestionsError(e.message));
  }
}

function* updateSecurityquestionsHandler(payload: any) {
  try {
    const data = yield httpPut("/security-configuration/security-questions", {}, payload.payload);
    if (data.ErrorCode) {
      throw new Error(data.Message);
    }
    yield put(updateSecurityQuestionsSuccess(data));
  } catch (e) {
    yield put(updateSecurityQuestionsError(e.message));
  }
}

function* addSecurityquestionsHandler(payload: any) {
  try {
    const data = yield httpPost("/security-configuration/security-questions", {}, payload.payload);
    if (data.ErrorCode) {
      throw new Error(data.Message);
    }
    if (data.AddQuestion.ErrorCode) {
      throw new Error(data.AddQuestion.Message);
    }
    yield put(addSecurityQuestionsSuccess(data));
  } catch (e) {
    yield put(addSecurityQuestionsError(e.message));
  }
}

function* deleteSecurityquestionsHandler(payload: any) {
  try {
    const data = yield httpDelete("/security-configuration/security-questions", {}, payload.payload);
    if (data.ErrorCode) {
      throw new Error(data.Message);
    }
    yield put(deleteSecurityQuestionsSuccess(payload.payload));
  } catch (e) {
    yield put(deleteSecurityQuestionsError(e.message));
  }
}

function* updateSecurityquestionRenderCountHandler(payload: any) {
  try {
    const data = yield httpPut("/security-configuration/security-questions/count-question-limit", {}, payload.payload);
    if (data.ErrorCode) {
      throw new Error(data.Message);
    }
    yield put(updateSecurityQuestionRenderCountSuccess(data));
  } catch (e) {
    yield put(updateSecurityQuestionRenderCountError(e.message));
  }
}

export function* watchSecurityquestions() {
  yield takeLatest(getSecurityQuestionsAction.type, getSecurityquestionsHandler);
  yield takeLatest(updateSecurityQuestionsAction.type, updateSecurityquestionsHandler);
  yield takeLatest(addSecurityQuestionsAction.type, addSecurityquestionsHandler);
  yield takeLatest(deleteSecurityQuestionsAction.type, deleteSecurityquestionsHandler);
  yield takeLatest(updateSecurityQuestionRenderCountAction.type, updateSecurityquestionRenderCountHandler);
}

function* getDuoSecondFactorAuthenticationHandler() {
  try {
    const data = yield httpGet(`/security-configuration/two-factor-auth/duo-settings`);
    if (data.ErrorCode) {
      throw new Error(data.Message);
    }
    yield put(getDuoSecondFactorAuthSuccess(data));
  } catch (e) {
    yield put(getDuoSecondFactorAuthError(e.message));
  }
}

function* updateDuoSecondFactorAuthenticationHandler(payload: any) {
  try {
    const data = yield httpPut("/security-configuration/two-factor-auth/duo-settings", {}, payload.payload);
    if (data.ErrorCode) {
      throw new Error(data.Message);
    }
    yield put(updateDuoSecondFactorAuthSuccess(data));
    const secondFactorAuth = yield select((state: RootSchema) => state.securityConfiguration.secondFactorAuthentication);
    const updatedData = { ...secondFactorAuth.Data, IsDuoAuthenticatorEnabled: data.IsEnabled };
    yield put(getSecondFactorAuthSuccess(updatedData));
  } catch (e) {
    yield put(updateDuoSecondFactorAuthError(e.message));
  }
}

export function* watchDuoSecondFactorAuth() {
  yield takeLatest(getDuoSecondFactorAuth.type, getDuoSecondFactorAuthenticationHandler);
  yield takeLatest(updateDuoSecondFactorAuth.type, updateDuoSecondFactorAuthenticationHandler);
}

function* getGoogleAuthenticatorHandler() {
  try {
    const data = yield httpGet(`/security-configuration/two-factor-auth/google-authenticator-settings`);
    if (data.ErrorCode) {
      throw new Error(data.Message);
    }
    yield put(getGoogleAuthenticatorSuccess(data));
  } catch (e) {
    yield put(getGoogleAuthenticatorError(e.message));
  }
}

function* updateGoogleAuthenticatorHandler(payload: any) {
  try {
    const data = yield httpPost("/security-configuration/two-factor-auth/google-authenticator-settings", {}, payload.payload);
    if (data.ErrorCode) {
      throw new Error(data.Message);
    }
    yield put(updateGoogleAuthenticatorSuccess(data));
    const secondFactorAuth = yield select((state: RootSchema) => state.securityConfiguration.secondFactorAuthentication);
    const updatedData = { ...secondFactorAuth.Data, IsAuthenticatorEnabled: data.IsEnabled };
    yield put(getSecondFactorAuthSuccess(updatedData));
  } catch (e) {
    yield put(updateGoogleAuthenticatorError(e.message));
  }
}

export function* watchGoogleAuthenticator() {
  yield takeLatest(getGoogleAuthenticator.type, getGoogleAuthenticatorHandler);
  yield takeLatest(updateGoogleAuthenticator.type, updateGoogleAuthenticatorHandler);
}

function* getPushNotifyHandler() {
  try {
    const data = yield httpGet(`/security-configuration/two-factor-auth/push-notification-settings`);
    if (data.ErrorCode) {
      throw new Error(data.Message);
    }
    yield put(getPushNotificationSuccess(data));
  } catch (e) {
    yield put(getPushNotificationError(e.message));
  }
}

function* updatePushNotifyHandler(payload: any) {
  try {
    const data = yield httpPut("/security-configuration/two-factor-auth/push-notification-settings", {}, payload.payload);
    if (data.ErrorCode) {
      throw new Error(data.Message);
    }
    yield put(updatePushNotificationSuccess(data));
    const secondFactorAuth = yield select((state: RootSchema) => state.securityConfiguration.secondFactorAuthentication);
    const updatedData = { ...secondFactorAuth.Data, IsPushAuthenticatorEnabled: data.IsEnabled };
    yield put(getSecondFactorAuthSuccess(updatedData));
  } catch (e) {
    yield put(updatePushNotificationError(e.message));
  }
}

function* addPushNotifyHandler(payload: any) {
  try {
    const data = yield httpPost("/security-configuration/two-factor-auth/push-notification-settings", {}, payload.payload);
    if (data.ErrorCode) {
      throw new Error(data.Message);
    }
    yield put(addPushNotificationSuccess(data));
  } catch (e) {
    yield put(addPushNotificationError(e.message));
  }
}

export function* watchPushNotify() {
  yield takeLatest(getPushNotification.type, getPushNotifyHandler);
  yield takeLatest(updatePushNotification.type, updatePushNotifyHandler);
  yield takeLatest(addPushNotification.type, addPushNotifyHandler);
}

function* fetchQuestionsSaga() {
  try {
    const response = yield call(httpGet, "/security-configuration/security-questions/render-count");
    const { Question } = response;
    const securityQuestions: SecurityQuestionSchema = {
      Data: {
        questions: [],
        renderCount: 0,
        limit: 0
      }
    };

    if (!Question.ErrorCode && Array.isArray(Question.Data)) {
      securityQuestions.Data.renderCount = response.RenderCount.RenderQuestionCount;
      securityQuestions.Data.limit = response.Question.Data.length;
      securityQuestions.Data.questions = Question.Data.map((question) => ({
        key: question.QuestionId,
        question: question.Question
      }));
    }
    yield put({
      type: SecurityQuestionAction.FETCH_QUESTIONS_SUCCESS,
      payload: securityQuestions
    });
  } catch (error) {
    yield put({
      type: SecurityQuestionAction.FETCH_QUESTIONS_ERROR,
      payload: error.message
    });
  }
}

function* addQuestionSaga(action) {
  try {
    const response = yield call(httpPost, "/security-configuration/security-questions", {}, action.payload);
    const responseObj = {
      payload: "SECURITY_QUESTION_ADDED_SUCCESSFULLY",
      type: SecurityQuestionAction.ADD_QUESTION_SUCCESS
    };
    if (response.AddQuestion && response.AddQuestion.ErrorCode) {
      responseObj.payload = response.AddQuestion.Description;
      responseObj.type = SecurityQuestionAction.ADD_QUESTION_ERROR;
      yield put(responseObj);
    } else {
      yield put(responseObj);
      yield put(fetchQuestionsRequest());
    }
  } catch (error) {
    yield put({
      type: SecurityQuestionAction.ADD_QUESTION_ERROR,
      payload: error
    });
  }
}

function* updateQuestionSaga(action) {
  try {
    const response = yield call(httpPut, "/security-configuration/security-questions", {}, action.payload);
    if (!response.ErrorCode && Array.isArray(response.Data)) {
      const updatedQuestions = response.Data.map((question) => ({
        key: question.QuestionId,
        question: question.Question
      }));
      yield put({
        type: SecurityQuestionAction.UPDATE_QUESTION_SUCCESS,
        payload: {
          questions: updatedQuestions,
          message: "SECURITY_QUESTION_UPDATED_SUCCESSFULLY"
        }
      });
      yield put(fetchQuestionsRequest());
    } else {
      yield put({
        type: SecurityQuestionAction.UPDATE_QUESTION_ERROR,
        payload: response.message
      });
    }
  } catch (error) {
    yield put({
      type: SecurityQuestionAction.UPDATE_QUESTION_ERROR,
      payload: error
    });
  }
}

function* deleteQuestionSaga(action) {
  try {
    yield call(httpDelete, "/security-configuration/security-questions", {}, { questionID: action.payload });
    yield put({
      type: SecurityQuestionAction.DELETE_QUESTION_SUCCESS,
      payload: "SECURITY_QUESTION_REMOVED_SUCCESSFULLY"
    });
    yield put(fetchQuestionsRequest());
  } catch (error) {
    yield put({
      type: SecurityQuestionAction.DELETE_QUESTION_ERROR,
      payload: error
    });
  }
}
function* updateCountLimitSaga(action) {
  try {
    const res = yield call(
      httpPut,
      "/security-configuration/security-questions/count-question-limit",
      {},
      {
        QuestionCount: { RenderQuestionCount: action.payload.count },
        QuestionLimit: {
          MaximumFailedSecurityQuestionAttempts: action.payload.limit
        }
      }
    );
    if (res && res.QuestionCount && !res.QuestionCount.ErrorCode) {
      yield put(fetchQuestionsRequest());
      yield put(initAppBasicInfoAction(true));
      yield put(updateCountLimitSuccess("SETTING_SAVED_SUCCESSFULLY"));
    } else {
      yield put(updateCountLimitFailure(res.QuestionCount.message));
    }
  } catch (error) {
    yield put(updateCountLimitFailure("SETTING_COULD_NOT_SAVED_SUCCESSFULLY"));
  }
}

export function* watchSecurityQuestions() {
  yield takeLatest(SecurityQuestionAction.FETCH_QUESTIONS_REQUEST, fetchQuestionsSaga);
  yield takeLatest(SecurityQuestionAction.ADD_QUESTION_REQUEST, addQuestionSaga);
  yield takeLatest(SecurityQuestionAction.UPDATE_QUESTION_REQUEST, updateQuestionSaga);
  yield takeLatest(SecurityQuestionAction.DELETE_QUESTION_REQUEST, deleteQuestionSaga);
  yield takeLatest(SecurityQuestionAction.UPDATE_COUNT_LIMIT_REQUEST, updateCountLimitSaga);
}
// function* getSecurityQuestionsHandler() {
//   try {
//     yield put(getSecurityQuestionsLoadingAction());

//     const data: SecurityQuestionsSchema = yield httpGet(
//       "/security-configuration/security-questions/render-count",
//       {}
//     );

//     yield put(getSecurityQuestionsSuccessAction({ ...data }));
//   } catch (e) {
//     yield put(getSecurityQuestionsErrorAction(e.message));
//   }
// }

// export function* watchGetSecurityQuestions() {
//   while (true) {
//     yield take(SecurityQuestionsAction.GET_SECURITY_QUESTIONS);
//     yield call(getSecurityQuestionsHandler);
//   }
// }

// function* getWebhookSecretsHandler() {
//   try {
//     yield put(getWebhookSecretsLoadingAction());

//     const data: WebhookSecretsSchema = yield httpGet(
//       "/security-configuration/api-credentials/secondary-secret",
//       {
//         fields: "Data(Description,Roles)"
//       }
//     );

//     yield put(getWebhookSecretsSuccessAction({ ...data }));
//   } catch (e) {
//     yield put(getWebhookSecretsErrorAction(e.message));
//   }
// }

// export function* watchGetWebhookSecrets() {
//   while (true) {
//     yield take(WebhookSecretsAction.GET_WEBHOOK_SECRETS_OPTIONS);
//     yield call(getWebhookSecretsHandler);
//   }
// }
